
const loginMessageErrorKey: string = 'LoginMessageError';

export const saveLoginMessageError = (code: string): void  => {
    localStorage.setItem(loginMessageErrorKey, code)
}

export const getLoginMessageError = (): string | null  => {
    const message: string | null | undefined = localStorage.getItem(loginMessageErrorKey);
    if (message) {
        return message;
    }
    return null;
}

export const removeLoginMessageError = (): void  => {
    localStorage.removeItem(loginMessageErrorKey)
}